import { getAnalytics, logEvent } from 'firebase/analytics';
import { app } from './firebase';

// Initialize analytics
const analytics = getAnalytics(app);

// Common events
export const AnalyticsEvents = {
  // Authentication events
  SIGN_UP: 'sign_up',
  LOGIN: 'login',
  LOGOUT: 'logout',

  // Plant identification events
  PLANT_IDENTIFICATION: 'plant_identification',
  IDENTIFICATION_ERROR: 'identification_error',

  // Disease detection events
  DISEASE_DETECTION: 'disease_detection',
  DISEASE_DETECTION_ERROR: 'disease_detection_error',

  // Credit events
  PURCHASE_CREDITS: 'purchase_credits',
  CREDIT_USAGE: 'credit_usage',

  // Feature usage events
  CAMERA_CAPTURE: 'camera_capture',
  IMAGE_UPLOAD: 'image_upload',
  VIEW_HISTORY: 'view_history',

  // User engagement events
  PAGE_VIEW: 'page_view',
  FEATURE_INTERACTION: 'feature_interaction'
};

// Analytics helper functions
export const Analytics = {
  // Track page views
  logPageView: pageName => {
    logEvent(analytics, AnalyticsEvents.PAGE_VIEW, {
      page_name: pageName,
      timestamp: new Date().toISOString()
    });
  },

  // Track authentication events
  logSignUp: method => {
    logEvent(analytics, AnalyticsEvents.SIGN_UP, {
      method,
      timestamp: new Date().toISOString()
    });
  },

  logLogin: method => {
    logEvent(analytics, AnalyticsEvents.LOGIN, {
      method,
      timestamp: new Date().toISOString()
    });
  },

  logLogout: () => {
    logEvent(analytics, AnalyticsEvents.LOGOUT, {
      timestamp: new Date().toISOString()
    });
  },

  // Track plant identification events
  logPlantIdentification: (success, details = {}) => {
    logEvent(analytics, AnalyticsEvents.PLANT_IDENTIFICATION, {
      success,
      ...details,
      timestamp: new Date().toISOString()
    });
  },

  logIdentificationError: error => {
    logEvent(analytics, AnalyticsEvents.IDENTIFICATION_ERROR, {
      error_message: error.message,
      error_code: error.code,
      timestamp: new Date().toISOString()
    });
  },

  // Track disease detection events
  logDiseaseDetection: (success, details = {}) => {
    logEvent(analytics, AnalyticsEvents.DISEASE_DETECTION, {
      success,
      ...details,
      timestamp: new Date().toISOString()
    });
  },

  logDiseaseDetectionError: error => {
    logEvent(analytics, AnalyticsEvents.DISEASE_DETECTION_ERROR, {
      error_message: error.message,
      error_code: error.code,
      timestamp: new Date().toISOString()
    });
  },

  // Track credit-related events
  logCreditPurchase: (amount, cost) => {
    logEvent(analytics, AnalyticsEvents.PURCHASE_CREDITS, {
      amount,
      cost,
      timestamp: new Date().toISOString()
    });
  },

  logCreditUsage: (amount, feature) => {
    logEvent(analytics, AnalyticsEvents.CREDIT_USAGE, {
      amount,
      feature,
      timestamp: new Date().toISOString()
    });
  },

  // Track feature usage
  logCameraCapture: () => {
    logEvent(analytics, AnalyticsEvents.CAMERA_CAPTURE, {
      timestamp: new Date().toISOString()
    });
  },

  logImageUpload: () => {
    logEvent(analytics, AnalyticsEvents.IMAGE_UPLOAD, {
      timestamp: new Date().toISOString()
    });
  },

  logHistoryView: type => {
    logEvent(analytics, AnalyticsEvents.VIEW_HISTORY, {
      type,
      timestamp: new Date().toISOString()
    });
  },

  // Track feature interactions
  logFeatureInteraction: (feature, action) => {
    logEvent(analytics, AnalyticsEvents.FEATURE_INTERACTION, {
      feature,
      action,
      timestamp: new Date().toISOString()
    });
  }
};
